<template>
  <div style="width:100%">
    <v-card width="400" style="margin-left:auto;margin-right:auto;" outlined>
      <v-card-title>
        <h2>{{ $t("request_password.header") }}</h2>
      </v-card-title>
      <v-card-text>
        <p>{{ $t("request_password.header_description") }}</p>
        <v-form @submit="resetPassword">
          <v-text-field type="password" :label="$t('request_password.new_password')" v-model="password"></v-text-field>
          <v-text-field type="password" :label="$t('request_password.repeat_new_password')" v-model="password_repeat"></v-text-field>
          <v-btn type="submit" depressed>{{ $t("request_password.request") }}</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { auth } from "../schmucklicloud";
import { Notifications } from "../notification";
export default {
  mounted() {},
  data() {
    return {
      password: "",
      password_repeat: ""
    };
  },
  methods: {
    getUrlParameter(name, url) {
      if (!url) url = location.href;
      // eslint-disable-next-line
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    },
    async resetPassword(e) {
      e.preventDefault();

      var reset_token = this.getUrlParameter("token", window.location.href);
      if (this.password === this.password_repeat) {
        var response = await auth.updateResetPassword(
          reset_token,
          this.password
        );
        if (response.isOK) {
          Notifications.show(this.$t("request_password.notification.new_password_has_been_set"));
          this.$router.replace("/login");
        } else {
          Notifications.show(response.message);
          this.password = "";
          this.password_repeat = "";
        }
      } else {
        Notifications.show(this.$t("request_password.notification.passwords_do_not_match"));
        this.password = "";
        this.password_repeat = "";
      }
    }
  }
};
</script>

<style>
</style>